"use strict";

import React from "react";
import Raphael from "raphael";

import ColorPickerDot from "../color-picker/ColorPickerDot";

class CategoryColorPickerComponent extends React.Component {
    getColorHex = () => {
        let Dyn = this.props.Dyn;
        var colorString = Dyn.colorUtil.calcCategoryColor(
            this.props.attributeObj.statsPreFilter,
            this.props.attributeObj.color,
            this.props.categoryObj,
            false,
            this.props.attributeObj.colorMap,
            this.props.attributeObj.isSortAscending
        ).colorString;
        return Raphael.getRGB(colorString).hex;
    };

    render = () => {
        let Dyn = this.props.Dyn;
        return (
            <ColorPickerDot
                size={8}
                color={this.getColorHex()}
                colorsArray={Dyn.colorUtil.categoryColorOptions}
                onChange={(color) => {
                    this.props.attributeObj.setColorMapForCategory(
                        this.props.categoryObj,
                        color.hex
                    );
                    if (Dyn.plotView) {
                        Dyn.plotView.refresh({ action: "setDataColor" });
                    }
                }}
                Dyn={Dyn}
            />
        );
    };
}

export default CategoryColorPickerComponent;
